module.exports = __webpack_public_path__ + "img/code-quality-icon.52b900d2.svg";